import { z } from 'zod';
export const dolapBoyutu = z.enum(['KUCUK', 'ORTA', 'BUYUK', 'EKSTRA']);
export const dolapDurumu = z.enum(['MUSAIT', 'MESGUL', 'REZERVE', 'BAKIM', 'CEVRIMDISI']);
export const dolap = z.object({
    id: z.string(),
    noktaId: z.string(),
    noktaKod: z.string().optional(),
    noktaAd: z.string().optional(),
    numara: z.string(),
    boyut: dolapBoyutu,
    cihazUid: z.string().nullable().optional(),
    durum: dolapDurumu,
    kapiDurumu: z.string(),
    pilMv: z.number().int().nullable().optional(),
    rssi: z.number().int().nullable().optional(),
    sonPing: z.string().datetime().nullable().optional(),
    sonOlay: z.string().datetime().nullable().optional(),
    kiralamaSaati: z.number().int(),
    periyotUcreti: z.string(),
    saatlikUcret: z.string(),
    cezaUcreti: z.string(),
    olusturmaTarihi: z.string().datetime(),
});
export const dolapOlusturIstegi = z.object({
    noktaId: z.string().min(1),
    numara: z.string().min(1).max(20),
    boyut: dolapBoyutu.default('ORTA'),
    kiralamaSaati: z.number().int().min(1).max(720).default(24),
    periyotUcreti: z.coerce.number().min(0).default(0),
    saatlikUcret: z.coerce.number().min(0).default(0),
    cezaUcreti: z.coerce.number().min(0).default(0),
});
// Admin tarafindan ayarlanabilir durumlar (MESGUL/REZERVE sistem tarafindan set edilir).
export const dolapDurumuAyarlanabilir = z.enum(['MUSAIT', 'BAKIM', 'CEVRIMDISI']);
export const dolapGuncelleIstegi = dolapOlusturIstegi
    .partial()
    .omit({ noktaId: true })
    .extend({ durum: dolapDurumuAyarlanabilir.optional() });
export const dolapSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(20),
    arama: z.string().optional(),
    noktaId: z.string().optional(),
    durum: dolapDurumu.optional(),
});
//# sourceMappingURL=dolap.js.map